export function wordToUpper(word: string) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
